import { gql } from '@apollo/client';

const UPDATE_ACCOUNT_STATUS = gql`
  mutation UpdateStatusOnAccounts(
    $accountIds: [String!]!
    $agentName: String! = "anonymous"
    $customerId: String!
    $operation: AccountUpdateStatusOp!
    $reasonCode: AccountStatusReasonCodeV2!
    $statusCode: AccountStatusCode!
    $startDate: String
    $stopDate: String
  ) {
    updateStatusOnAccounts(
      customerId: $customerId
      updateStatusOnAccountsInput: {
        accountIds: $accountIds
        agentName: $agentName
        operation: $operation
        reasonCode: $reasonCode
        statusCode: $statusCode
        startDate: $startDate
        stopDate: $stopDate
      }
    ) {
      identifiers
    }
  }
`;

const UPDATE_DECEASED_STATUS = gql`
  mutation UpdateDeceasedStatus($accountIds: [String!]!, $customerId: String!) {
    updateDeceasedFlagAndStatusesV2(
      accountIds: $accountIds
      customerId: $customerId
    ) {
      accountProcessingResults {
        accountId
        closedDeceasedStatusError
        containsFailures
        creditRevokedDeceasedStatusError
        deceasedFlagError
        statementPreferencesError
      }
      communicationPreferencesError
      containsFailures
      fundingAccountFetchError
    }
  }
`;

export { UPDATE_ACCOUNT_STATUS, UPDATE_DECEASED_STATUS };
